import React from "react";

const EmployeeId = (props) => {
  if(props) {
      let userDetails = props.userid.split('|');
      return <span>{userDetails[0]}</span>;
  } else
    return <span></span>;
};

export default EmployeeId;
